import { useNavigate } from "@tanstack/react-router";
import { useRecommendationsCount } from "@/api/recommendations";
import { Button } from "@/components/base/buttons/button";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { useMerchant } from "@/providers/MerchantProvider";

type RecommendedCreatorsButtonProps = {
  collaborationId: string;
  /** When set, the recommendations page will invite creators to all collabs in this Smart Group */
  groupId?: string;
};

export const RecommendedCreatorsButton = ({ collaborationId, groupId }: RecommendedCreatorsButtonProps) => {
  const merchant = useMerchant();
  const navigate = useNavigate();

  const { data, isLoading } = useRecommendationsCount(collaborationId);

  const hasRecommendations = data?.hasUnactionedRecommendations ?? false;

  if (isLoading || !hasRecommendations) {
    return (
      <Tooltip title="All recommended creators for this collaboration have been reviewed.">
        <TooltipTrigger>
          <span>
            <Button color="primary" size="sm" isDisabled>
              Recommended Creators
            </Button>
          </span>
        </TooltipTrigger>
      </Tooltip>
    );
  }

  return (
    <Button
      color="primary"
      size="sm"
      onClick={() =>
        navigate({
          to: "/merchant/$merchantId/collaborations/target/$collaborationId/recommendations",
          params: { merchantId: merchant, collaborationId },
          search: groupId ? { groupId } : {},
        })
      }
    >
      Recommended Creators
    </Button>
  );
};
